import React from 'react';
import { connect } from 'react-redux';
import * as calcTypes from '../../Constants/priceCalculationTypes';
import Grid from '../../Components/Grid/Grid';
import { BlikkCustomerInfoCard } from '../../Components/OrderPlacement/ProductComponents/Blikk/BlikkCustomerInfoCard';
import { BlikkProductInfoCard } from '../../Components/OrderPlacement/ProductComponents/Blikk/BlikkProductInfoCard';
import { BlikkTransactionsCard } from '../../Components/OrderPlacement/ProductComponents/Blikk/BlikkTransactionsCard';
import { BlikkAdditionalUsersCard } from '../../Components/OrderPlacement/ProductComponents/Blikk/BlikkAdditionalUsersCard';
import { BlikkTrialSearch } from '../../Components/OrderPlacement/ProductComponents/Blikk/BlikkTrialSearch';
import { BlikkProductSummaryCard } from '../../Components/OrderPlacement/ProductComponents/Blikk/BlikkProductSummaryCard';

function BlikkProductContainer({...props}){
  const { product } = props;

  return (
    <>
      {(product.blikkAccountFound || product.isTrial) ? <>
        <Grid.Row>
          <Grid.Row.Column width={4}>
            <BlikkCustomerInfoCard {...props} />
          </Grid.Row.Column>
          <Grid.Row.Column>
            <BlikkProductInfoCard {...props} />
          </Grid.Row.Column>
          <Grid.Row.Column>
            <BlikkTransactionsCard {...props} />
          </Grid.Row.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Row.Column width={4}>
            <BlikkAdditionalUsersCard {...props} />
          </Grid.Row.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Row.Column>
            <BlikkProductSummaryCard {...props} priceCalcType={calcTypes.priceCalculationTypes.order} />
          </Grid.Row.Column>
        </Grid.Row>
      </>
        : <Grid.Row>
          <Grid.Row.Column>
            <BlikkTrialSearch {...props} />
          </Grid.Row.Column>
        </Grid.Row>}
    </>
  );
};

const mapStateToProps = (state) => ({
  licenseTypes: state.OrderReducer.blikkLicenseTypes,
  trialSearchResults: state.OrderReducer.trialSearchResults,
});

export default connect(mapStateToProps, null)(BlikkProductContainer);